<template>
  <div class="text-left">
    <v-card>
    <v-tabs v-model="tab">
      <v-tab>
        {{ $t("form.basicData") }}
      </v-tab>
      <v-tab>
        {{ $t("account.status") }}
        <v-icon v-if="investigator.account.activation_status === false" color="red" class="ml-2">
          mdi-lock
        </v-icon>
        <v-icon v-else-if="investigator.account !== null &&
        (investigator.account.expiration_date === null ||
          new Date(investigator.account.expiration_date).getTime() <
            new Date().getTime() + 24*31*60*60*1000)" color="orange" class="ml-2">
          mdi-lock-clock
        </v-icon>
        <v-icon v-else color="gray" class="ml-2">
          mdi-lock-open
        </v-icon>
      </v-tab>
      <v-tab v-if="$route.params.id !== undefined">
        {{ $t("vinculations") }}
        <v-icon v-if="last_vinculation !== null &&
        (last_vinculation.end_date === null ||
          new Date(last_vinculation.end_date).getTime() >
            new Date().getTime() + 24*31*60*60*1000)" color="grey" class="ml-2">
          mdi-account
        </v-icon>
        <v-icon v-else-if="last_vinculation !== null &&
        (last_vinculation.end_date === null ||
          new Date(last_vinculation.end_date).getTime() >
            new Date().getTime())" color="orange" class="ml-2">
          mdi-account-clock
        </v-icon>
        <v-icon v-else-if="all_vinculations !== null && all_vinculations.length > 0" color="red" class="ml-2">
          mdi-account-alert
        </v-icon>
        <v-icon v-else color="gray" class="ml-2">
          mdi-account-remove
        </v-icon>
      </v-tab>
      <v-tab v-if="$route.params.id !== undefined">
        {{ $t("workplaceAssignations") }}
        <v-icon v-if="last_workplace_assignation !== null &&
        (last_workplace_assignation.expiration_date === null ||
          new Date(last_workplace_assignation.expiration_date).getTime() >
            new Date().getTime() + 24*31*60*60*1000)" color="grey" class="ml-2">
          mdi-archive
        </v-icon>
        <v-icon v-else-if="last_workplace_assignation !== null &&
        (last_workplace_assignation.expiration_date === null ||
          new Date(last_workplace_assignation.expiration_date).getTime() >
            new Date().getTime())" color="orange" class="ml-2">
          mdi-archive-clock
        </v-icon>
        <v-icon v-else-if="last_workplace_assignation !== null && last_workplace_assignation.length > 0" color="red" class="ml-2">
          mdi-archive-alert
        </v-icon>
        <v-icon v-else color="gray" class="ml-2">
          mdi-archive-remove
        </v-icon>
      </v-tab>
      <!-- <v-tab v-if="$route.params.id !== undefined">
        {{ $t("affiliations") }}
      </v-tab> -->
      <v-tab>
        {{ $t("form.publicProfile") }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card>
          <v-form class="pa-6 py-3" ref="personal_form">
            <h5>
              {{ $t("form.givenAndFamilyName") }}
            </h5>
            <v-row>
              <v-col cols="12" sm="6" lg="4" class="py-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.given_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'given_name')"
                  :label="$t('form.name')"
                  required
                  outlined
                  :rules="rules.nameRules"
                  :counter="40"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="4" class="py-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.family_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'family_name')"
                  :label="$t('form.familyName')"
                  required
                  outlined
                  :rules="rules.nameRules"
                  :counter="40"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="!showAlternativeNameFields && !hasAlternativeName"
                cols="12"
                sm="6"
                lg="4"
                class="py-0 d-flex align-start"
              >
                <v-btn
                  text
                  small
                  color="primary"
                  class="mt-2"
                  @click="showAlternativeNameFields = true"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  {{ $t("button.setalternativename") }}
                </v-btn>
              </v-col>
            </v-row>
            <template v-if="showAlternativeNameFields || hasAlternativeName">
              <h5>
                {{ $t("form.givenAndFamilyNameAlt") }}
              </h5>
              <v-row>
                <v-col cols="12" sm="6" lg="4" class="py-0">
                  <v-text-field
                    v-model="investigator.person.alt_name.given_name"
                    @blur="normalizePersonNameField(investigator.person.alt_name, 'given_name')"
                    :label="$t('form.name')"
                    required
                    outlined
                    :counter="40"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="4" class="py-0">
                  <v-text-field
                    v-model="investigator.person.alt_name.family_name"
                    @blur="normalizePersonNameField(investigator.person.alt_name, 'family_name')"
                    :label="$t('form.familyName')"
                    required
                    outlined
                    :counter="40"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <h5>{{ $t("form.email") }}</h5>
            <ArrayFieldForm
              v-model="investigator.person.email"
              name-field="email"
              :label="$t('form.email')"
              :suggest-example-emails="true"
              :person-id="investigator.person.id"
            />
            <h5>{{ $t("form.incharge") }}</h5>
            <SelectPeopleList :items-selected="personsInCharge" />

            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <h5>
                  {{ $t("form.dni") }}
                </h5>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-select
                      v-model="investigator.person.id_number.type"
                      :label="$t('type')"
                      outlined
                      :items="identificationOptions"
                      item-text="text"
                      item-value="value"
                      :rules="rules.fieldRequired"
                      @change="$refs.idNumberText.validate()"
                    ></v-select
                  ></v-col>
                  <v-col cols="8" class="py-0">
                    <v-text-field
                      v-model="investigator.person.id_number.value"
                      :label="$t('label.value')"
                      required
                      outlined
                      ref="idNumberText"
                      :rules="[dniValueRulesFunction]"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <h5>
                  {{ $t("form.mobile") }}
                </h5>
                <v-row>
                  <v-col class="py-0">
                    <v-text-field
                      v-model="investigator.person.number"
                      outlined
                      :label="$t('form.mobile')"
                      :rules="[optionalTelephoneRuleFunction]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="py-0">
                <h5>{{ $t("form.gender") }}</h5>
                <v-row>
                  <v-col class="py-0 mt-1 mb-4">
                    <v-btn-toggle
                      v-model="investigator.person.gender"
                      mandatory
                    >
                      <v-btn value="male">
                        {{ $t("form.male") }}
                      </v-btn>
                      <v-btn value="female">
                        {{ $t("form.female") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <h5>{{ $t("form.citicenships") }}</h5>
            <v-row>
              <v-col cols="12">
                <ArrayFieldForm
                  v-model="citicenship"
                  name-field="citicenship"
                  :label="$t('form.citicenships')"
                />
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.publication.research_areas") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-select
                  :items="researchAreas"
                  v-model="investigator.person.research_areas"
                  :label="$t('form.publication.research_areas')"
                  required
                  :item-text="'name.' + $i18n.locale"
                  item-value="id"
                  outlined
                  multiple
                  :rules="rules.fieldRequired"
                ></v-select>
              </v-col>
            </v-row>
            <v-divider class="clearfix mt-2 mb-3" />
            <v-row>
              <v-col cols="4" class="py-0 d-flex justify-center">
                <v-checkbox
                  class="big"
                  v-model="investigator.person.hidden"
                  :label="$t('form.hidden')"
                />
              </v-col>
              <v-col cols="4" class="py-0 d-flex justify-center">
                <v-checkbox
                  class="big"
                  v-model="investigator.person.featured"
                  :label="$t('form.featured')"
                />
              </v-col>
              <v-col cols="4" class="py-0 d-flex justify-center">
                <v-tooltip bottom content-class="admin-help-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-checkbox
                        class="big"
                        v-model="investigator.person.admin"
                        :label="$t('form.admin')"
                      />
                    </span>
                  </template>
                  <span>{{ $t("form.admin_help") }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.comments") }}
            </h5>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-textarea
                  v-model="investigator.person.comments"
                  :label="$t('form.comments')"
                  outlined
                  :rules="rules.char_max_3500"
                  :counter="3500"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-divider class="clearfix mt-4 mb-3" />
            <div class="text-center">
              <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
              <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card>
          <v-form class="pa-6" ref="account_form">
            <h5>
              {{ $t("form.account_configuration") }}
            </h5>
            <v-row
              class="account-config-row"
              :class="investigator.account.activation_status ? 'account-enabled-row' : 'account-disabled-row'"
            >
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field
                  v-model="investigator.account.username"
                  :label="$t('form.username')"
                  required
                  outlined
                  :rules="rules.usernameRules"
                >
                  <template v-if="!investigator.account.username" v-slot:append>
                    <UsernameSuggestions :person="investigator.person" @select="investigator.account.username = $event" />
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="py-0">
                <div class="expiration-date-with-actions">
                  <v-menu
                    v-model="menu_account"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="investigator.account.expiration_date"
                        :label="$t('form.expiration_date')"
                        prepend-inner-icon="event"
                        readonly
                        outlined
                        clearable
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="investigator.account.expiration_date"
                      @input="menu_account = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        class="ml-1 mt-2"
                        :disabled="!lastVinculationEndDate"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-calendar-import</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="copyVinculationEndDateToAccount">
                        <v-list-item-title>
                          {{ $t("button.copyVinculationEndDate") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="py-0">
                <v-text-field
                  v-model="investigator.account.nextcloudquota"
                  :label="$t('form.nextcloudquota')"
                  @blur="applyAccountQuotaDefault"
                  required
                  outlined
                  :rules="rules.nextcloudquotaRules"
                  type="number"
                  suffix="GB"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0 account-activation-switch">
                <v-switch
                  class="big"
                  :label="investigator.account.activation_status ? $t('form.activation_status_enabled') : $t('form.activation_status_disabled')"
                  v-model="investigator.account.activation_status"
                />
              </v-col>
            </v-row>
            <v-row class="mt-n2">
              <v-col cols="12" md="8" class="py-0 text-md-right">
                <p v-if="sendingActivationLink">
                  {{ $t("form.sendingActivationLink") }}
                </p>
                <p v-else-if="investigator.account.sent_activation_link_date === null">
                  {{ $t("form.sentActivationLinkNever") }}
                </p>
                <p v-else>
                  {{ $t("form.sentActivationLinkOn", { "date": timeDifference(new Date(investigator.account.sent_activation_link_date)).toLowerCase() }) }}
                </p>
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-tooltip bottom :disabled="!activationButtonTooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="d-inline-block" v-bind="attrs" v-on="on">
                      <v-btn outlined :disabled="isActivationButtonDisabled" @click="sendActivationLink">
                        <v-icon left>mdi-mail</v-icon>
                        <span
                          class="d-none d-lg-inline"
                          :class="activationButtonTextClasses"
                        >
                          {{ $t("button.sendActivationLink") }}
                        </span>
                        <span
                          class="d-inline d-lg-none"
                          :class="activationButtonTextClasses"
                        >
                          {{ $t("button.sendActivationLinkShort") }}
                        </span>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ activationButtonTooltip }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <h5>
              {{ $t("form.building") }}
            </h5>
            <v-row>
              <v-col cols="8" sm="5" class="py-0">
                <v-text-field
                  v-model="investigator.account.alarm_code"
                  :label="$t('form.alarm_code')"
                  outlined
                  :rules="rules.alarmCodeRules"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <h5>{{ $t("form.picture_account") }}</h5>
                <v-row class="ma-0">
                  <v-col cols="12" sm="6" class="pa-0">
                    <v-checkbox
                      v-model="investigator.account.picture_website_private"
                      :label="$t('form.picture_website_private')"
                      class="mt-2"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" class="pa-0">
                    <v-checkbox
                      v-model="investigator.account.picture_website_temporary"
                      :label="$t('form.picture_website_temporary')"
                      class="mt-2"
                    />
                  </v-col>
                </v-row>
                <UploadImage
                  :path="
                    this.$store.state.endpoint +
                      '/account/' +
                      this.investigator.account.person
                  "
                  :url="
                    this.$store.state.endpoint +
                      this.investigator.account.picture_website
                  "
                  :object="{
                    name: this.investigator.account.picture_website
                  }"
                  :object_created="this.investigator.account.person !== undefined"
                  name_field="picture_website"
                  :image-max-width="95"
                  :image-max-height="95"
                />
              </v-col>
              <v-col cols="12" md="6" v-if="!isFetchingAccount">
                <h5>{{ $t("form.category_website") }}</h5>
                <v-tabs v-model="tab_categorywebsite">
                  <v-tab
                    class="capitalize"
                    v-for="(item, index) in Object.keys(investigator.account.category_website)"
                    :key="index"
                  >
                    {{ $t("form." + item) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab_categorywebsite">
                  <v-tab-item
                    class="mt-2"
                    v-for="(item, index) in Object.keys(investigator.account.category_website)"
                    :key="index"
                  >
                    <v-text-field
                      v-model="investigator.account.category_website[item]"
                      :label="$t('form.title')"
                      outlined
                    ></v-text-field>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
            <h5 class="pt-3">
              {{ $t("form.list.additional.services") }}
            </h5>
            <v-row class="mt-0">
              <v-col
                cols="12"
                sm="6"
                md="4"
                v-for="service in sortedServices"
                :key="service.code"
                class="py-0"
              >
                <v-checkbox
                  multiple
                  v-model="investigator.account.services"
                  :value="service.id"
                  class="service-checkbox"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      <div class="service-label-row">
                        <span class="service-label-name">{{ service.name }}</span>
                        <v-tooltip v-if="service.restricted" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="ml-2"
                              color="red"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-lock
                            </v-icon>
                          </template>
                          {{ $t("form.service_restricted_tooltip") }}
                        </v-tooltip>
                        <v-tooltip v-if="service.requires_agreement" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="ml-2"
                              color="blue"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-file-sign
                            </v-icon>
                          </template>
                          {{ $t("form.service_requires_agreement_tooltip") }}
                        </v-tooltip>
                        <v-tooltip
                          v-if="service.exclusive_with && service.exclusive_with.length"
                          top
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              class="ml-2"
                              color="orange"
                              small
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-call-split
                            </v-icon>
                          </template>
                          {{ exclusiveServicesLabel(service) }}
                        </v-tooltip>
                      </div>
                      <div
                        v-if="service.contact_people && service.contact_people.length"
                        class="grey--text text--darken-1 caption"
                      >
                        {{ contactPeopleLabel(service.contact_people) }}
                      </div>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-divider class="clearfix mt-4 mb-3" />
            <div class="text-center">
              <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
              <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="$route.params.id !== undefined">
        <EditVinculationList :person="$route.params.id" />
      </v-tab-item>
      <v-tab-item v-if="$route.params.id !== undefined">
        <EditWorkplaceAssignationList
          :person="$route.params.id"
          :vinculation-end-date="lastVinculationEndDate"
        />
      </v-tab-item>
      <!-- <v-tab-item v-if="$route.params.id !== undefined">
        <EditAffiliationList :person="$route.params.id" />
      </v-tab-item> -->
      <v-tab-item>
        <v-card>
          <v-form
            class="pa-6"
            ref="publicProfile_form"
          >
            <v-row>
              <v-col
                cols="12"
                class="pl-0 pl-lg-6"
                v-if="investigator.publicProfile === false"
              >
                <v-alert
                  color="purple darken-2"
                  type="warning"
                  icon="mdi-hand-back-left"
                  prominent
                  text
                  class="rounded-bl-0 rounded-br-0"
                >
                  <h5>{{ $t('forms.info.noPublicProfile.title') }}</h5>
                  <div v-html="$t('forms.info.noPublicProfile.message')"></div>
                </v-alert>
              </v-col>
              <v-col cols="12" class="pl-0 pl-lg-6">
                <h5>{{ $t("account.preferences.title") }}</h5>
              </v-col>
              <v-col cols="12" lg="6" class="pl-0 pl-lg-6">
                <div class="profile-preference-item">
                  <span class="font-weight-medium mr-2">{{ $t("account.preferences.treatment") }}</span>
                  <span>{{ publicProfileTreatmentLabel }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="6">
                <div class="profile-preference-item">
                  <span class="font-weight-medium mr-2">{{ $t("account.preferences.language") }}</span>
                  <span>{{ preferredLanguageLabel }}</span>
                </div>
              </v-col>
              <v-col cols="12" class="pl-0 pl-lg-6">
                <h5>{{ $t("form.biography") }}</h5>
              </v-col>
              <v-col cols="12">
                <v-tabs v-model="biographyTab">
                  <v-tab class="capitalize" v-for="item in biographyItems" :key="item.tab">
                    {{ $t(item.tab) }}
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="biographyTab">
                  <v-tab-item v-for="item in biographyItems" :key="item.tab">
                    <Editor-text
                      class="mr-2"
                      :key="item.key"
                      :text="item.biography"
                      :language="item.language"
                      @change-content="changeContent"
                      :disabled="true"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <v-col cols="12" md="2" class="pl-0 pl-lg-6">
                <v-subheader>
                  <span>{{ $t("form.picture_portrait") }}</span>
                </v-subheader>
              </v-col>
              <v-col cols="12" md="10">
                <v-avatar size="96" tile>
                  <v-img v-if="publicProfilePortraitUrl" :src="publicProfilePortraitUrl" />
                  <v-icon v-else size="80" color="grey lighten-1">mdi-account-box</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" md="2" class="pl-0 pl-lg-6">
                <v-subheader>
                  <span>{{ $t("form.birthdate") }}</span>
                </v-subheader>
              </v-col>
              <v-col cols="12" md="10" class="d-flex align-center flex-wrap">
                <span class="mr-3">{{ publicProfileField("birthdate") }}</span>
                <v-chip small :color="publicProfileVisibilityColor(investigator.publicProfile.public_birthdate)" text-color="white">
                  <v-icon left small>{{ investigator.publicProfile.public_birthdate ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
                  {{ publicProfileVisibilityLabel(investigator.publicProfile.public_birthdate) }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                <h5 class="mt-4">{{ $t("personal.scientific_accounts") }}</h5>
              </v-col>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="profile in academiaProfiles" :key="profile.model">
                        <td class="font-weight-medium">{{ profile.title }}</td>
                        <td>{{ publicProfileAccountValue("academia_profile", profile) }}</td>
                        <td class="text-right">
                          <v-chip small :color="publicProfileVisibilityColor(publicProfileAccountIsPublic('academia_profile', profile.model))" text-color="white">
                            <v-icon left small>{{ publicProfileAccountIsPublic("academia_profile", profile.model) ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
                            {{ publicProfileVisibilityLabel(publicProfileAccountIsPublic("academia_profile", profile.model)) }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <h5 class="mt-4">{{ $t("personal.social_accounts") }}</h5>
              </v-col>
              <v-col cols="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="profile in socialProfiles" :key="profile.model">
                        <td class="font-weight-medium">{{ profile.title }}</td>
                        <td>{{ publicProfileAccountValue("social_profile", profile) }}</td>
                        <td class="text-right">
                          <v-chip small :color="publicProfileVisibilityColor(publicProfileAccountIsPublic('social_profile', profile.model))" text-color="white">
                            <v-icon left small>{{ publicProfileAccountIsPublic("social_profile", profile.model) ? "mdi-eye" : "mdi-eye-off" }}</v-icon>
                            {{ publicProfileVisibilityLabel(publicProfileAccountIsPublic("social_profile", profile.model)) }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <h5 class="mt-4">{{ $t("personal.ssh_keys") }}</h5>
              </v-col>
              <v-col cols="12">
                <div v-if="publicProfileSshKeys.length">
                  <v-chip
                    v-for="(key, index) in publicProfileSshKeys"
                    :key="index"
                    class="ma-1 public-profile-ssh-key"
                    label
                    small
                  >
                    {{ key }}
                  </v-chip>
                </div>
                <span v-else>-</span>
              </v-col>
            </v-row>
            <v-divider class="clearfix mt-4 mb-3" />
            <div class="text-center">
              <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    </v-card>
  </div>

</template>

<script>
import axios from "axios";
import validationRules from "../../../mixins/validationRules";
import SelectPeopleList from "../../../components/reusables/SelectPeopleList";
import ArrayFieldForm from "../../../components/reusables/ArrayFieldForm";
import EditVinculationList from "./EditVinculationList";
import EditWorkplaceAssignationList from "./EditWorkplaceAssignationList";
// import EditAffiliationList from "./EditAffiliationList";
import investigator_model from "../../../mixins/model_utils/investigator_model";
import investigatorData from "../../../mixins/investigator_data";
import EditorText from "../../../components/reusables/EditorText";
import UploadImage from "../../../components/layouts/UploadImage";
import investigatorTablesMethods from "../../../mixins/investigatorTablesMethods";
import UsernameSuggestions from "../../../components/users/UsernameSuggestions.vue";

const ACCOUNT_TRACKED_FIELDS = [
  "username",
  "expiration_date",
  "nextcloudquota",
  "activation_status"
];
export default {
  components: {
    UsernameSuggestions,
    // EditAffiliationList,
    EditWorkplaceAssignationList,
    EditVinculationList,
    SelectPeopleList,
    ArrayFieldForm,
    EditorText,
    UploadImage
  },
  mixins: [validationRules, investigatorData, investigator_model, investigatorTablesMethods],
  name: "EditInvestigatorDetail",
  data: () => ({
    menu_account: false,
    languageOptions: [],
    url: null,
    tab: 1,
    biographyTab: 1,
    maxBirthdayDate: "",
    step: 1,
    menu: false,
    last_workplace_assignation : null,
    last_vinculation: null,
    all_vinculations: [],
    investigator: {
      publicProfile: false
    },
    tab_categorywebsite: 0,
    isFetchingAccount: true,
    accountExists: null,
    citicenship: [""],
    sendingActivationLink: false,
    initialAccountState: null,
    personNameIndex: {},
    showAlternativeNameFields: false,
    academiaProfiles: [
      {
        title: "Orcid id",
        model: "orcid_id",
        prefix: "https://orcid.org/",
        label: "0000-0000-0000-0000"
      },
      {
        title: "Researcher ID",
        model: "researcher_id",
        prefix: "https://www.researcherid.com/rid/",
        label: "A-0000-0000"
      },
      {
        title: "Scopus Author ID",
        model: "scopus_author_id",
        prefix: "https://scopus.com/authid/detail.url?authorId=",
        label: "00000000000"
      },
      {
        title: "Google Scholar",
        model: "google_scholar",
        prefix: "https://scholar.google.es/citations?user=",
        label: "x0xxxxAAAAAJ"
      }
    ],
    socialProfiles: [
      {
        title: "X",
        model: "twitter",
        prefix: "https://x.com/",
        label: "username"
      },
      {
        title: "BlueSky",
        model: "bluesky",
        prefix: "https://bsky.app/profile/",
        label: "handle"
      },
      {
        title: "Youtube",
        model: "youtube",
        prefix: "https://youtube.com/@",
        label: "handle"
      },
      {
        title: "Threads",
        model: "threads",
        prefix: "https://threads.net/@",
        label: "handle"
      },
      {
        title: "Facebook",
        model: "facebook",
        prefix: "https://www.facebook.com/",
        label: "username"
      },
      {
        title: "Instagram",
        model: "instagram",
        prefix: "https://www.instagram.com/",
        label: "username"
      },
      {
        title: "TikTok",
        model: "tiktok",
        prefix: "https://www.tiktok.com/@",
        label: "username"
      },
      {
        title: "Linkedin",
        model: "linkedin",
        prefix: "https://es.linkedin.com/in/",
        label: "username"
      },
      {
        title: "Telegram",
        model: "telegram",
        prefix: "https://t.me/",
        label: "username"
      },
      {
        title: "Github",
        model: "github",
        prefix: "https://github.com/",
        label: "username"
      },
      {
        title: "Página personal",
        model: "pagina_personal",
        prefix: "https://",
        label: "www.yourwebsite.com/"
      }
    ],
  }),

  created() {
    this.loadVinculationsAndWorkplaceAssignations();
    this.loadBirthdayDate();
    this.getAllResearchAreas();
    this.getServices();
    this.getLanguageOptions();
    this.getPersonNames();
    if (this.$route.params.id > -1) {
      this.getInvestigatorAndPersonsInCharge(
        this.$store.state.endpoint + "/person/" + this.$route.params.id
      );
      this.getAccount();
      this.getPublicProfile();
    }
  },
  mounted() {
    const linkedTab = Number(this.$route.query.tab);
    this.tab = Number.isInteger(linkedTab) && linkedTab >= 0 && linkedTab <= 4 ? linkedTab : 0;
    this.biographyTab = 0;
  },

  computed: {
    hasAlternativeName() {
      const altName =
        this.investigator &&
        this.investigator.person &&
        this.investigator.person.alt_name
          ? this.investigator.person.alt_name
          : {};
      return Boolean(
        (altName.given_name && altName.given_name.trim()) ||
        (altName.family_name && altName.family_name.trim())
      );
    },
    publicProfilePortraitUrl() {
      if (
        this.investigator.publicProfile === false ||
        !this.investigator.publicProfile.picture_portrait
      ) {
        return "";
      }
      const picture = this.investigator.publicProfile.picture_portrait;
      if (picture.indexOf("http://") === 0 || picture.indexOf("https://") === 0) {
        return picture;
      }
      return this.$store.state.endpoint + picture;
    },
    publicProfileSshKeys() {
      if (
        this.investigator.publicProfile === false ||
        !Array.isArray(this.investigator.publicProfile.pubkey)
      ) {
        return [];
      }
      return this.investigator.publicProfile.pubkey.filter(key => key && key.trim());
    },
    publicProfileTreatmentLabel() {
      if (
        this.investigator.publicProfile === false ||
        !this.investigator.publicProfile.treatment
      ) {
        return "-";
      }
      return this.$t("treatment." + this.investigator.publicProfile.treatment);
    },
    preferredLanguageLabel() {
      const language =
        this.investigator.publicProfile !== false &&
        this.investigator.publicProfile.preferred_language
          ? this.investigator.publicProfile.preferred_language
          : this.investigator.account && this.investigator.account.preferred_language
            ? this.investigator.account.preferred_language
            : "";
      const labels = {
        gl: "language.galego",
        es: "language.castellano",
        en: "language.english"
      };
      return labels[language] ? this.$t(labels[language]) : "-";
    },
    sortedServices() {
      if (!this.services || !Array.isArray(this.services)) {
        return [];
      }
      return this.services
        .filter(service => service && service.hidden !== true)
        .slice()
        .sort((a, b) => {
          const orderDiff = (a.order || 0) - (b.order || 0);
          if (orderDiff !== 0) {
            return orderDiff;
          }
          return String(a.name || "").localeCompare(String(b.name || ""));
        });
    },
    lastVinculationEndDate() {
      return this.last_vinculation && this.last_vinculation.end_date
        ? this.last_vinculation.end_date
        : null;
    },
    processPersonalData() {
      let number = "";
      if (typeof this.investigator.person.number === "number") {
        number = this.investigator.person.number.toString();
      } else if (typeof this.investigator.person.number === "string") {
        number = this.investigator.person.number.replace(/[^\d]/g, "");
      }
      let emails = [];
      this.investigator.person.email.forEach(email => {
        emails.push(email.trim());
      });
      let citicenships = [];
      this.citicenship.forEach(x => {
        citicenships.push(x.trim());
      });
      let data = {
        preferred_name: {
          given_name:
            this.investigator.person.preferred_name.given_name !== undefined
              ? this.investigator.person.preferred_name.given_name.trim()
              : "",
          family_name:
            this.investigator.person.preferred_name.family_name !== undefined
              ? this.investigator.person.preferred_name.family_name.trim()
              : ""
        },
        alt_name: {
          given_name:
            this.investigator.person.alt_name.given_name !== undefined
              ? this.investigator.person.alt_name.given_name.trim()
              : "",
          family_name:
            this.investigator.person.alt_name.family_name !== undefined
              ? this.investigator.person.alt_name.family_name.trim()
              : ""
        },
        email: emails,
        citicenship: citicenships,
        incharge: this.personsInCharge
          .filter(item => item.id != null)
          .map(function(item) {
            return item.id;
          }),
        id_number: this.investigator.person.id_number,
        gender: this.investigator.person.gender,
        number: number !== '' ? number : null,
        hidden: this.investigator.person.hidden,
        featured: this.investigator.person.featured,
        admin: this.investigator.person.admin,
        research_areas: this.investigator.person.research_areas.map(a => typeof a == "object" ? a.id : a).filter(area =>
          Number.isInteger(area)
        ),
        comments: this.investigator.person.comments
      };
      return data;
    },
    processAccountData() {
      let data = {
        person: this.$route.params.id,
        username: this.investigator.account.username,
        alarm_code: this.investigator.account.alarm_code,
        uid: this.investigator.account.uid,
        preferred_language: this.investigator.account.preferred_language,
        picture_account: this.investigator.account.picture_account,
        picture_website_private: this.investigator.account.picture_website_private === true,
        picture_website_temporary: this.investigator.account.picture_website_temporary === true,
        activation_status: this.investigator.account.activation_status,
        nextcloudquota: this.investigator.account.nextcloudquota,
        expiration_date: this.investigator.account.expiration_date || null,
        services: this.investigator.account.services,
        category_website: this.investigator.account.category_website,
      };
      if(data.category_website === undefined || data.category_website === null || data.category_website["es"] === undefined || data.category_website["es"] === null){
        data.category_website = {"es": "", "en": "", "gl": ""};
      }
      if (data.nextcloudquota === null || data.nextcloudquota === undefined || data.nextcloudquota === '') {
        if (this.accountDefaults && this.accountDefaults.nextcloudquota !== null) data.nextcloudquota = this.accountDefaults.nextcloudquota;
        else delete data.nextcloudquota;
      }
      return data;
    },
    hasPendingAccountChanges() {
      if (!this.investigator.account || !this.initialAccountState) {
        return false;
      }
      return ACCOUNT_TRACKED_FIELDS.some(field => {
        const currentValue = this.normalizeAccountField(
          field,
          this.investigator.account[field]
        );
        return currentValue !== this.initialAccountState[field];
      });
    },
    disableActivationBecauseUnsaved() {
      return this.hasPendingAccountChanges;
    },
    isActivationButtonDisabled() {
      return this.sendingActivationLink || this.disableActivationBecauseUnsaved;
    },
    activationButtonTooltip() {
      if (this.disableActivationBecauseUnsaved) {
        return this.$t("form.activation_link_disabled_tooltip");
      }
      return "";
    },
    activationButtonTextClasses() {
      return {
        "activation-button-text--strikethrough": this.disableActivationBecauseUnsaved
      };
    }
  },

  methods: {
    normalizePublicProfile(profile) {
      if (!profile.text_website) {
        profile.text_website = { es: "", en: "", gl: "" };
      }
      if (!profile.academia_profile) {
        profile.academia_profile = {};
      }
      if (!profile.social_profile) {
        profile.social_profile = {};
      }
      if (!Array.isArray(profile.pubkey)) {
        profile.pubkey = [];
      }
      this.academiaProfiles.forEach(item => {
        if (!profile.academia_profile[item.model]) {
          profile.academia_profile[item.model] = { value: "", public: false };
        }
      });
      this.socialProfiles.forEach(item => {
        if (!profile.social_profile[item.model]) {
          profile.social_profile[item.model] = { value: "", public: false };
        }
      });
      return profile;
    },
    publicProfileField(field) {
      if (this.investigator.publicProfile === false) {
        return "-";
      }
      return this.investigator.publicProfile[field] || "-";
    },
    publicProfileAccount(section, model) {
      if (
        this.investigator.publicProfile === false ||
        !this.investigator.publicProfile[section] ||
        !this.investigator.publicProfile[section][model]
      ) {
        return { value: "", public: false };
      }
      return this.investigator.publicProfile[section][model];
    },
    publicProfileAccountValue(section, profile) {
      const value = this.publicProfileAccount(section, profile.model).value;
      if (!value) {
        return "-";
      }
      return profile.prefix ? profile.prefix + value : value;
    },
    publicProfileAccountIsPublic(section, model) {
      return this.publicProfileAccount(section, model).public === true;
    },
    publicProfileVisibilityColor(isPublic) {
      return isPublic ? "green darken-2" : "grey darken-1";
    },
    publicProfileVisibilityLabel(isPublic) {
      return isPublic ? this.$t("form.public") : this.$t("form.not_public");
    },
    getPersonNames() {
      const path = this.$store.state.endpoint + "/personName";
      axios
        .get(path)
        .then(response => {
          const index = {};
          response.data.forEach(person => {
            const name =
              person.preferred_name.given_name +
              " " +
              person.preferred_name.family_name;
            index[person.id] = name;
          });
          this.personNameIndex = index;
        })
        .catch(error => {
          console.log(error);
        });
    },
    contactPeopleLabel(people) {
      if (!Array.isArray(people)) {
        return "";
      }
      const names = people
        .map(person => this.getContactPersonName(person))
        .filter(name => name);
      return names.join(", ");
    },
    exclusiveServicesLabel(service) {
      if (
        !service ||
        !Array.isArray(service.exclusive_with) ||
        service.exclusive_with.length === 0
      ) {
        return this.$t("form.exclusive_with");
      }
      const names = service.exclusive_with
        .map(item => this.getExclusiveServiceName(item))
        .filter(name => name);
      if (names.length === 0) {
        return this.$t("form.exclusive_with");
      }
      return this.$t("form.exclusive_with") + ": " + names.join(", ");
    },
    getExclusiveServiceName(service) {
      if (!service) {
        return "";
      }
      if (typeof service === "object") {
        if (service.name) {
          return service.name;
        }
        if (service.id !== undefined && service.id !== null) {
          const found = this.services.find(item => item && item.id === service.id);
          return found && found.name ? found.name : String(service.id);
        }
        return "";
      }
      const found = this.services.find(item => item && item.id === service);
      return found && found.name ? found.name : String(service);
    },
    getContactPersonName(person) {
      if (!person) {
        return "";
      }
      if (typeof person === "number") {
        return this.personNameIndex[person] || String(person);
      }
      if (typeof person === "string") {
        return this.personNameIndex[person] || person;
      }
      if (person.preferred_name && person.preferred_name.given_name) {
        return (
          person.preferred_name.given_name +
          (person.preferred_name.family_name ? " " + person.preferred_name.family_name : "")
        );
      }
      if (person.name) {
        return person.name;
      }
      return "";
    },
    normalizeAccountField(field, value) {
      if (value === undefined) {
        value = null;
      }
      switch (field) {
        case "username":
          return value !== null ? String(value).trim() : "";
        case "expiration_date":
          if (value === null || value === "") {
            return null;
          }
          if (value instanceof Date) {
            return value.toISOString().substr(0, 10);
          }
          return String(value);
        case "nextcloudquota":
          if (value === "" || value === null) {
            return null;
          }
          return Number(value);
        case "activation_status":
          return value === true;
        default:
          return value;
      }
    },
    captureInitialAccountState(account = null) {
      const source = account || this.investigator.account;
      if (!source) {
        this.initialAccountState = null;
        return;
      }
      const snapshot = {};
      ACCOUNT_TRACKED_FIELDS.forEach(field => {
        snapshot[field] = this.normalizeAccountField(field, source[field]);
      });
      this.initialAccountState = snapshot;
    },
    loadVinculationsAndWorkplaceAssignations(){
      let path = this.$store.state.endpoint + "/vinculation/person/" + this.$route.params.id + "/last";
      axios
        .get(path)
        .then(response => {
          this.last_vinculation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
        path = this.$store.state.endpoint + "/vinculation/person/" + this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.all_vinculations = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      path = this.$store.state.endpoint + "/workplaceAssignation/last/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.last_workplace_assignation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadBirthdayDate() {
      let date = new Date();
      date.setFullYear(date.getFullYear() - 15);
      this.maxBirthdayDate = date.toISOString().substr(0, 10);
    },
    getAccount() {
      this.isFetchingAccount = true;
      let path =
        this.$store.state.endpoint + "/account/" + this.$route.params.id;
      return axios
        .get(path)
        .then(response => {
          if(response.data.category_website === null || response.data.category_website === undefined || response.data.category_website["es"] === undefined || response.data.category_website["es"] === null){
            response.data.category_website = {"es": "", "en": "", "gl": ""};
          }
          if (response.data.picture_website_private === undefined || response.data.picture_website_private === null) {
            response.data.picture_website_private = false;
          }
          if (response.data.picture_website_temporary === undefined || response.data.picture_website_temporary === null) {
            response.data.picture_website_temporary = false;
          }
          this.investigator.account = response.data;
          if (response.data.nextcloudquota === null || response.data.nextcloudquota === undefined || response.data.nextcloudquota === '') {
            this.investigator.account.nextcloudquota = this.accountDefaults.nextcloudquota;
          }
          this.accountExists = true;
          this.captureInitialAccountState(response.data);
          this.isFetchingAccount = false;
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            this.accountExists = false;
            this.captureInitialAccountState();
          } else {
            this.accountExists = null;
            this.$store.commit("alert", { color: "error", text: this.$t('account.loadError') });
          }
          this.isFetchingAccount = false;
        });
    },
    getPublicProfile() {
      this.biographyItems = [
        { tab: "language.galego", biography: "", language: "gl", key: "gl0" },
        {
          tab: "language.castellano",
          biography: "",
          language: "es",
          key: "es0"
        },
        { tab: "language.english", biography: "", language: "en", key: "en0" }
      ];
      let path =
        this.$store.state.endpoint + "/publicProfile/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.investigator.publicProfile = this.normalizePublicProfile(response.data);
          this.load_biographies_and_re_render();
        })
        .catch(error => {
          this.investigator.publicProfile = false;
        });
    },
    changeContent(language, content) {
      switch (language) {
        case "gl":
          this.biographyItems[0].biography = content;
          break;
        case "es":
          this.biographyItems[1].biography = content;
          break;
        case "en":
          this.biographyItems[2].biography = content;
          break;
      }
    },
    load_biographies_and_re_render() {
      this.biographyItems[0].biography = this.investigator.publicProfile.text_website.gl;
      this.biographyItems[0].key = "gl1";
      this.biographyItems[1].biography = this.investigator.publicProfile.text_website.es;
      this.biographyItems[1].key = "es1";
      this.biographyItems[2].biography = this.investigator.publicProfile.text_website.en;
      this.biographyItems[2].key = "en1";
    },
    copyVinculationEndDateToAccount() {
      if (this.lastVinculationEndDate) {
        this.investigator.account.expiration_date = this.lastVinculationEndDate;
      }
    },
    getLanguageOptions() {
      let path = this.$store.state.endpoint + "/utils/languages";
      axios
        .get(path)
        .then(response => {
          this.languageOptions = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    async save() {
      if (this.$route.params.id > -1 && this.accountExists === null) {
        await this.getAccount();
        if (this.accountExists === null) return;
      }
      if (
        this.$refs.personal_form.validate() &&
        this.$refs.account_form.validate()
      ) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint + "/person/" + this.$route.params.id;
          axios
            .patch(path, this.processPersonalData)
            .then(response => {
              path = this.$store.state.endpoint + "/account";
              const accountRequest = this.accountExists
                ? axios.patch(path + "/" + this.$route.params.id, this.processAccountData)
                : axios.post(path, this.processAccountData);
              accountRequest
                .then(response => {
                  this.accountExists = true;
                  this.investigator.account = { ...this.investigator.account, ...response.data };
                  this.captureInitialAccountState();
                  this.$store.commit("alert", {
                    color: "success",
                    text: this.$t("message.correct.updateItem")
                  });
                })
                .catch(error => {
                  console.log(error);
                  this.$store.commit("alert", {
                    color: "error",
                    text: error.response.data
                  });
                });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/person";
          axios
            .post(path, this.processPersonalData)
            .then(response => {
              path = this.$store.state.endpoint + "/account";
              const data = this.processAccountData;
              data["person"] = response.data.id;
              axios
                .post(path, data)
                .then(response => {
                  this.$store.commit("alert", {
                    color: "success",
                    text: this.$t("message.correct.createItem")
                  });
                  this.$router.push("/manage/edit/researchers");
                })
                .catch(error => {
                  console.log(error);
                  this.$store.commit("alert", {
                    color: "error",
                    text: error.response.data
                  });
                });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      } else {
        this.$store.commit("alert", {
          color: "error",
          text: this.$t("form.validation.error")
        });
      }
    },
    _sendActivationLink(){
      this.sendingActivationLink = true;
      let path = this.$store.state.endpoint + "/account/" + this.$route.params.id + "/sendActivationLink";
      axios
        .patch(path, {})
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.sendEmail")
          });
          let sentDate = new Date().toISOString();
          if (response && response.data && response.data.sent_activation_link_date) {
            sentDate = response.data.sent_activation_link_date;
          }
          if (this.investigator.account) {
            this.$set(this.investigator.account, "sent_activation_link_date", sentDate);
          }
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("message.error.sendEmail")
          });
        })
        .finally(() => {
          this.sendingActivationLink = false;
        });
    },
    sendActivationLink(){
      if(this.investigator.account.sent_activation_link_date !== null){
        if(confirm(this.$t("message.confirm.sendActivationLink"))){
          this._sendActivationLink();
        }
      }
      else{
        this._sendActivationLink();
      }
    }
  }
};
</script>
<style scoped>
.activation-button-text--strikethrough {
  text-decoration: line-through;
}

.service-label-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  flex-wrap: wrap;
}

.service-label-name {
  display: inline;
}

.public-profile-ssh-key {
  height: auto;
  max-width: 100%;
  white-space: normal;
  word-break: break-all;
}

::v-deep .service-checkbox .v-label {
  justify-content: flex-start;
  align-items: center;
}

.expiration-date-with-actions {
  display: flex;
  align-items: flex-start;
}

.expiration-date-with-actions .v-menu {
  flex: 1 1 auto;
}

.account-activation-switch {
  display: flex;
  align-items: flex-start;
}

.account-activation-switch .v-input {
  margin-top: 4px;
}

.account-config-row {
  width: 100%;
}

.profile-preference-item {
  display: flex;
  align-items: center;
  min-height: 32px;
}
</style>
